import http from "../utils/http";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

type CreateDocumentationParams = {
  appointmentId: string;
  values: Array<Record<string, string>>;
  noteType: string;
  patientId?: string;
};

export const documentationApi = {
  createDocumentation: async (params: CreateDocumentationParams) => {
    const { patientId, noteType, ...rest } = params;
    const response = await http.post(
      `/documentation/${patientId}?noteType=${noteType}`,
      rest
    );
    return response.data;
  }
};

export const useCreateDocumentation = (
  appointmentId: string,
  formType: [string, ...string[]],
  patientId?: string
) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (values: Record<string, string>) => {
      return documentationApi.createDocumentation({
        appointmentId,
        values: [values], // Wrap values in an array to match the expected format
        noteType: formType[0] === "intake" ? "intakeForm" : "consentForm",
        patientId
      });
    },
    onSuccess: () => {
      toast.success("Form submitted successfully!");
      navigate("/patient/appointments");
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || "Error submitting form");
    }
  });
};
